<div class="w100 row space-between">
  <div class="icon">
    <rr-icon name="settings"></rr-icon>
  </div>
  <rr-icon name="close" class="close" (click)="close()"></rr-icon>
</div>

<h3 i18n>
    @if (isUser(data)) {
        Avatar
    } @else {
        Logo
    }
</h3>
<input
  type="file"
  #file
  (change)="fileChangeEvent($event)"
  class="hidden"
  hidden
/>
<div
  (dragover)="onDragOver($event)"
  (drop)="onDropSuccess($event)"
  class="droparea"
>
  <div class="add" (click)="file.click()" tabindex="0">
    <rr-icon name="add"></rr-icon>
  </div>
  <span i18n class="tiny color-strong w100 text-center"
    >Drag & Drop your image here or click on the Button to change a file from
    your device.</span
  >
</div>
<div *ngIf="showWrongFileType == true" class="error row gap-8">
  <rr-icon name="error"></rr-icon>
  <div class="col">
    <h4 class="strong">Wrong File Type</h4>
    <span i18n>
            @if (isUser(data)) {
                Please add only image files for the avatar.
            } @else {
                Please add only image files for the logo.
            }
    </span>
  </div>
</div>
<image-cropper
  [imageChangedEvent]="imageChangedEvent"
  [imageFile]="imageFile"
  [maintainAspectRatio]="true"
  [aspectRatio]="1 / 1"
  output="base64"
  [resizeToWidth]="40"
  [roundCropper]="true"
  (imageCropped)="imageCropped($event)"
></image-cropper>

<div class="btnrow row justify-end gap-8">
  <rr-btn type="Secondary" (click)="close()">Close</rr-btn>
  <rr-btn type="Primary" (click)="save()">Save</rr-btn>
</div>

